import React from 'react';
import withView from '../../../../cmn/docAutomation/withView';
import FormLabel from '../../../../../library/form/components/FormLabel';
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormCheckbox from '../../../../../library/form/components/FormCheckbox';
import FormInput from '../../../../../library/form/components/FormInput';
import FormWrapper from '../../../../../library/form/components/FormWrapper'
import FormDialog from '../../../../../library/form/components/FormDialog';
import FormTitle from '../../../../../library/form/components/FormTitle'
import FormRichText from '../../../../../library/form/components/FormRichText'
import { UiGridColTwo, UiCol, UiRow } from "../../../../../library/layout/Index";

const ProcessHeaderEditor = (props) => {
    const { formObject, viewData, masterKeys, ...restProps } = props;
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{height: '270px'}}
            formStyle={{ width: '680px' }} formTitle={<FormTitle formObject={formObject} masterKeys={masterKeys} value="Proces Header" />} 
        >
            <UiGridColTwo>
                <UiCol>
                <ul>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "docID" }} value="Process ID" />
                        </span>
                        <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "docID" }} className='uiVal' />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "type" }} value="Process Type" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "type", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                    </li>
                    <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "subtype" }} >
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "subtype" }} value="Process Sub Type" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "subtype", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                    </FormWrapper>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "processName" }} value="Process Name" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "input", paramName: "processName" }} />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "processCode" }} value="Process Code" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "input", paramName: "processCode" }} />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "nickName" }} value="Nick Name" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "input", paramName: "nickName" }} />
                    </li>
                </ul>
                </UiCol>
                <UiCol>
                    <ul>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refNo" }} value="Ref No" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput" action={{ InputType: "input", paramName: "refNo" }} />
                    </li>
                    <li style={{display:"none"}}>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "qcTemplate" }} value="QC Template" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "qcTemplate", acMethod: "QCTemplate", acDepCtrl: { 'dparam': '%dataList.valLDT' } }} />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "unit1" }} value="Resource Time Unit" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "unit1", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "unit2" }} value="Resource Count Unit" />
                        </span>
                        <FormInput formObject={formObject} rowKey="" className="uiInput"
                                action={{ InputType: "ac", paramName: "unit2", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "requireResource" }} value="Require Mat." />
                        </span>
                        <FormCheckbox formObject={formObject} rowKey='' action={{ InputType: "onOff", paramName: "requireResource" }} />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isInHouse" }} value="Is Inhouse" />
                        </span>
                        <FormCheckbox formObject={formObject} rowKey='' action={{ InputType: "onOff", paramName: "isInHouse" }} />
                    </li>
                    <li>
                        <span className="uiLbl">
                            <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isActive" }} value="Active" />
                        </span>
                        <FormCheckbox formObject={formObject} rowKey='' action={{ InputType: "onOff", paramName: "isActive" }} />
                    </li>
                    </ul>
                </UiCol>
            </UiGridColTwo>
            <UiRow>
                <span className="uiLbl">
                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "desc" }} value="Remark" />
                </span>
                <FormRichText formObject={formObject} rowKey="" rows="2" cols="60" className="" action={{ paramName: "desc" }} />
            </UiRow>
        </FormDialog>
    )
}

export default withView(ProcessHeaderEditor, "processHeader", "processHeader")